export enum TypeReportEnum {
  Part = 'Part',
  Equipment = 'Equipment',
}
